import React from "react"
import Layout from "§/src/components/layout"
import { graphql } from "gatsby"

import Error from "§/src/components/error"
import { isEmpty } from "lodash"
import SEO from "§/src/components/seo"
import LoadingFrame from "§/src/components/atoms/loading-frame"
import { getFormattedDate } from "§/src/utils/functions"
import { useTranslation } from "react-i18next"

// Components
import Hero from "§/src/components/sections/hero"
import InvestorCards3el from "§/src/components/sections/investor-cards-3-el"
import VideoFull from "§/src/components/sections/video-full"

const SelectorSelection = React.lazy(() =>
  import("§/src/components/sections/selector-selection")
)
const RelatedNewsEvents = React.lazy(() =>
  import("§/src/components/sections/related-news-events")
)

// Switch Language
import { getFormattedLanguage } from "§/src/utils/functions"

export function Head(props) {
  const data = props.pageContext.data || {}
  const seo = data.seo || {}

  return (
    <React.Fragment>
      <html lang={getFormattedLanguage(process.env.GATSBY_SITE_LANG)}></html>
      <body className="home"></body>
      <SEO seo={seo} translations={props?.data?.lang?.translations} />
    </React.Fragment>
  )
}

const FrontPage = props => {
  const { t } = useTranslation()

  const data = props.pageContext.data || {}
  const docsPressReleases = props.pageContext.docsPressReleases || []
  docsPressReleases.sort((a, b) => {
    const x = getFormattedDate(a.media.date, "YYYYMMDD")
    const y = getFormattedDate(b.media.date, "YYYYMMDD")
    return y.localeCompare(x)
  })

  const docsFinancialReports = props.pageContext.docsFinancialReports || []
  docsFinancialReports.sort((a, b) => {
    const x = getFormattedDate(a.media.date, "YYYYMMDD")
    const y = getFormattedDate(b.media.date, "YYYYMMDD")
    return y.localeCompare(x)
  })

  const docsPressRelease = docsPressReleases[0]
  const docsFinancialReport = docsFinancialReports[0]

  const news = [docsPressRelease, docsFinancialReport].map(x => ({
    dateRaw: x.media.date,
    content: getFormattedDate(x.media.date, "D MMMM Y"),
    cta: ["url", x.media.documents[0].mediaItemUrl, t("Leggi"), "1"],
    pretitle: "INVESTOR RELATIONS",
    template: "light-blue",
    title: x.media.bundletitle || x.media.documents[0].title,
  }))
  news.sort((a, b) => {
    const x = getFormattedDate(a.dateRaw, "YYYYMMDD")
    const y = getFormattedDate(b.dateRaw, "YYYYMMDD")
    return y.localeCompare(x)
  })

  return (
    <Layout lang={["home"]}>
      {!isEmpty(props?.pageContext) ? (
        <React.Fragment>
          {data?.acfPages_home?.compHero && (
            <Hero data={data?.acfPages_home?.compHero} />
          )}

          {data.acfPages_home?.linkCards && (
            <InvestorCards3el
              data={data?.acfPages_home?.linkCards}
              investor={data?.acfPages_home?.investorCard}
              news={news[0]}
            />
          )}

          {data?.acfPages_home?.compVideo[0] && (
            <div className={"pb-5"}>
              <VideoFull data={data.acfPages_home?.compVideo[0]} />
            </div>
          )}

          <React.Suspense fallback={<LoadingFrame />}>
            {data?.acfPages_home?.selectorSelection && (
              <SelectorSelection
                data={data?.acfPages_home?.selectorSelection}
              />
            )}

            {props?.data && (
              <RelatedNewsEvents
                title={data?.acfPages_home?.relatedNewsAndEvents?.title}
                data={props?.data}
              />
            )}
          </React.Suspense>
        </React.Fragment>
      ) : (
        <Error message="Something Went Wrong" />
      )}
    </Layout>
  )
}
export default FrontPage

// Get last 2 posts and events.
export const postQuery = graphql`
  query GET_POSTS ($eq: String!) {
    relatedNews: allWpPost(
      sort: { date: DESC }
      limit: 2
      filter: {
        categories: {
          nodes: {
            elemMatch: {
              slug: { nin: [
                "uncategorized",
                "senza-categoria"
                ]
              }
            }
          }
        }
      }
    ) {
      nodes {
        excerpt
        uri
        date
        featuredImage {
          node {
            altText
            gatsbyImage(
              quality: 80
              aspectRatio: 1.6
              placeholder: BLURRED
              layout: CONSTRAINED
              width: 500
              formats: [AUTO, WEBP]
            )
          }
        }
        categories {
          nodes {
            name
          }
        }
      }
    }
    relatedEvents: allWpEvent(sort: { date: DESC }) {
      nodes {
        title
        uri
        cptEvent {
          date
          location
          link
        }
        eventCategories {
          nodes {
            name
          }
        }
      }
    }
    wpInfo: wpPage(isPostsPage: { eq: true }) {
      link
    }
    lang: wpPage(slug: { eq: $eq }) {
      translations {
        postUrl
        siteId
      }
    }
  }
`
